import { useTranslation } from 'react-i18next'

import { ProductsActionsCell } from 'components/Table'
import { useRebuildDomain } from 'features/inventory/domain/components/DomainsTable/hooks/useRebuildDomain/useRebuildDomain'
import { Product } from 'features/product'
import { ROUTES } from 'routes'
import { useDeleteAdUnit } from '../../hooks/useDeleteAdUnit'
import { ActionsCellProps } from './types'

const products: Product[] = [
  'prebidStack',
  'refresher',
  'viewabilityTools',
  'priceGenius',
  'unfilledRecovery',
]

export const ActionsCell = ({
  domain: { id: domainId, name },
  id,
  outOfPage,
  path,
}: ActionsCellProps): React.JSX.Element => {
  const { t } = useTranslation('features/adUnit')
  const { deleteAdUnit, loading } = useDeleteAdUnit({ path })
  const { rebuildDomain } = useRebuildDomain({ name })
  const filteredProducts: Product[] = products.filter(
    (product: Product): boolean => !(product === 'viewabilityTools' && outOfPage),
  )

  return (
    <ProductsActionsCell
      editPath={ROUTES.INVENTORY.AD_UNIT.EDIT}
      feature='adUnit'
      i18nResource={t}
      id={id}
      loading={loading}
      onDelete={() => void deleteAdUnit(id)}
      onRebuild={() => void rebuildDomain(domainId)}
      products={filteredProducts}
    />
  )
}
